import { isoToFlagEmoji } from "./profileCountries";

/**
 * National number length rules (digits only, no trunk leading 0).
 * Expand as product adds markets.
 */
export const PHONE_COUNTRY_RULES = /** @type {const} */ ([
  { iso: "IN", label: "India", dial: "+91", nationalLengths: [10] },
  { iso: "US", label: "United States", dial: "+1", nationalLengths: [10] },
  { iso: "CA", label: "Canada", dial: "+1", nationalLengths: [10] },
  { iso: "GB", label: "United Kingdom", dial: "+44", nationalLengths: [10, 11] },
  { iso: "AU", label: "Australia", dial: "+61", nationalLengths: [9] },
  { iso: "SG", label: "Singapore", dial: "+65", nationalLengths: [8] },
  { iso: "MY", label: "Malaysia", dial: "+60", nationalLengths: [9, 10] },
  { iso: "AE", label: "UAE", dial: "+971", nationalLengths: [9] },
  { iso: "SA", label: "Saudi Arabia", dial: "+966", nationalLengths: [9] },
  { iso: "DE", label: "Germany", dial: "+49", nationalLengths: [10, 11] },
  { iso: "FR", label: "France", dial: "+33", nationalLengths: [9] },
  { iso: "JP", label: "Japan", dial: "+81", nationalLengths: [10] },
  { iso: "CN", label: "China", dial: "+86", nationalLengths: [11] },
  { iso: "HK", label: "Hong Kong", dial: "+852", nationalLengths: [8] },
  { iso: "NZ", label: "New Zealand", dial: "+64", nationalLengths: [8, 9, 10] },
]);

/** @param {string} [iso] */
export function phoneRuleForIso(iso) {
  return PHONE_COUNTRY_RULES.find((r) => r.iso === iso) || null;
}

export function phoneCountrySelectOptions() {
  return PHONE_COUNTRY_RULES.map((r) => ({
    id: r.iso,
    label: `${r.label} (${r.dial})`,
    shortLabel: r.dial,
    prefix: isoToFlagEmoji(r.iso),
  }));
}

/**
 * @param {string} [national]
 */
export function digitsOnlyNational(national) {
  return String(national ?? "").replace(/\D/g, "");
}

/**
 * @param {string} [iso]
 * @param {string} [national]
 */
export function validateProfilePhone(iso, national) {
  const digits = digitsOnlyNational(national);
  if (!digits) return { ok: true, empty: true };
  const rule = phoneRuleForIso(iso || "");
  if (!rule) return { ok: false, error: "Choose a country code for your phone." };
  if (!rule.nationalLengths.includes(digits.length)) {
    const lenHint =
      rule.nationalLengths.length === 1
        ? `${rule.nationalLengths[0]} digits`
        : `${rule.nationalLengths.join(" or ")} digits`;
    return { ok: false, error: `${rule.label} numbers use ${lenHint}.` };
  }
  return {
    ok: true,
    empty: false,
    phoneCountryIso: rule.iso,
    phoneDialCode: rule.dial,
    phoneNationalNumber: digits,
  };
}

const CONTACT_EMAIL_RE =
  /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)+$/i;

/**
 * @param {string} [email]
 */
export function validateProfileContactEmail(email) {
  const raw = String(email ?? "").trim();
  if (!raw) return { ok: true, empty: true };
  if (raw.length > 120) return { ok: false, error: "Email must be at most 120 characters." };
  if (!CONTACT_EMAIL_RE.test(raw)) return { ok: false, error: "Enter a valid email address." };
  if (raw.toLowerCase().endsWith("@account.therallyally.com")) {
    return { ok: false, error: "Use a personal email you can verify, not your RallyAlly sign-in ID." };
  }
  return { ok: true, empty: false, contactEmail: raw.toLowerCase() };
}
